import React from "react";
import { EmptyState } from "../../../../ForBrands/ui/BrandUI";
import CollapsibleCard from "../../../../ForBrands/ui/CollapsibleCard";
import { LegendRow } from "../../../../ForBrands/ui/LegendItem";
import ShareTrack from "../../../../ForBrands/ui/charts/ShareTrack";
import { CHART, ROLE } from "../../../../ForBrands/ui/charts/chartTokens";
import { compositionView } from "../teamPerformanceModel";

// Roster Mix vs Peers (BUILD_SPEC B7, Jayson's T9): one row per player
// archetype in payload order, its data colour as a ringed swatch (B18), the
// squad's share of minutes in bm-orange against the peer average as an ink
// tick, the signed difference at the end (green or red). Both numbers are
// printed under each track (the mock's tooltip, as text). With no mix on
// file the card says so in the tab's empty state (no legend for nothing).

const RosterMixCard = ({ makeup, squadLabel, collapse }) => {
  const { rows, scale } = compositionView(makeup);
  const legend = [
    { key: "squad", swatch: "bar", color: ROLE.self, label: `${squadLabel} share of minutes` },
    { key: "peers", swatch: "tick", color: CHART.ink, label: "Peer average" },
  ];
  return (
    <CollapsibleCard title="Roster Mix vs Peers" titleAs="h3" subtitle="Share of the squad's minutes by player archetype." {...collapse}>
      {rows.length ? (
        <>
          <LegendRow items={legend} label="Roster mix legend" />
          {/* eslint-disable-next-line jsx-a11y/no-redundant-roles -- VoiceOver drops the list role of a list with no bullets */}
          <ul role="list" aria-label="Archetype share of minutes" className="flex flex-col gap-3">
            {rows.map((r) => (
              <li key={r.key}>
                <ShareTrack label={r.archetype} swatch={r.color} value={r.team} peer={r.peers} diff={r.diff} scale={scale} />
              </li>
            ))}
          </ul>
        </>
      ) : (
        <EmptyState>No archetype mix on file for this squad.</EmptyState>
      )}
    </CollapsibleCard>
  );
};

export default RosterMixCard;
